import React, { useContext } from "react";
import type { Features } from "byzantine/src/Feature";
import { jsonFromDocument } from "cerulean";

const UserFeaturesContext = React.createContext<Features>({});
export const UserFeaturesContextProvider = ({ children }: { children: React.ReactNode }) => {
  const userFeatures = jsonFromDocument("features") as Features;
  return (
    <UserFeaturesContext.Provider value={userFeatures}>
      {children}
    </UserFeaturesContext.Provider>
  );
};

export const useUserFeatures = () => useContext(UserFeaturesContext);

export default UserFeaturesContext;
